import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import {initReactI18next} from 'react-i18next';
const fallbackLng = ['en'];
const availableLanguages = [
  'English',
  'Korean',
  'Japanese',
  'Traditional Chinese',
  'Simplified Chinese',
  'Romanian',
  'Russian',
  'Canadian French',
];

const detectionOptions = {
  // order and from where user language should be detected
  order: ['navigator', 'htmlTag', 'path', 'subdomain'],

  // keys or params to lookup language from
  lookupQuerystring: 'lng',
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: 0,

  // cache user language on
  caches: ['localStorage', 'cookie'],
  excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

  // optional expire and domain for set cookie
  cookieMinutes: 10,
  cookieDomain: 'myDomain',
  // optional htmlTag with lang attribute, the default is:
  htmlTag: document.documentElement,

  // only detect languages that are in the whitelist
  checkWhitelist: true,
};

i18n
  .use(Backend)
  //.use(LanguageDetector) // detect user language
  .use(initReactI18next) // pass the i18n instance to react-i18next.

  .init({
    fallbackLng, // if user computer language is not on the list of available languages, than we will be using the fallback language specified earlier
    debug: false,
    whitelist: availableLanguages,
    detection: detectionOptions,
    backend: {
      loadPath:
        (process.env.NODE_ENV === 'development'
          ? '/'
          : process.env.REACT_APP_API_GATEWAY_URL_TRANS) +
        'locales/{{lng}}/{{ns}}.json',
      // customHeaders: {
      //   Authorization: 'Bearer ' + localStorage.getItem('awl_token'),
      // },
    },
    interpolation: {
      escapeValue: false,
    },
    nsSeparator: ':::',
    keySeparator: '::',
  });

export default i18n;
